<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Select from "@/components/c-select";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import moment from 'moment'
import { propertyService } from "../../../../services/reportservice/propertyservice.js";
import { servicehelpers } from "../../../../services/servicehelpers";


/* eslint-disable no-console */
export default {
  page: {
    title: "Property Gropu Summary Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { 
    Layout, 
    PageHeader, 
    Button,
    Select, 
    Input,
  },
  data() {
    return {
      data: [],
      projects: {},
      groupData: {},
      start_date: '',
      end_date: '',
      project_id: 1,
      group_id: 0,
    };
  },
  mounted() {
    this.loadingData();
    this.loadingpropertyGroupData(this.project_id);
  },
  methods: {
    loadingData: function() {
      servicehelpers.getProjectData().then(response => {
        this.projects = response;
      });

      
      
      propertyService.getPropertyChangePrice()
        .then(response => {
          this.data = response.data.list;
          this.start_date = response.data.start_date;
          this.end_date = response.data.end_date;
          this.project_name = response.data.project_name;

        });
    },

    loadingpropertyGroupData: function(projectId = 0) {
      servicehelpers.getGroupData(projectId).then(response => {
        this.groupData = response;
      });
    },

    projectChanged: function(event) {

      this.loadingpropertyGroupData(event);
    },

    submitSearch: function() {
      
      let data = '?project_id='+this.project_id +
      '&start_date='+this.start_date +
      '&end_date='+this.end_date;

      if(this.group_id != 0) {
        data += `&group_id=${this.group_id}`;
      }

      propertyService.getPropertyChangePrice(data)
        .then(response => {
           this.data = response.data.list;
          this.project_name = response.data.project_name;

      });
    },
    dateFormat: function(value){
      return moment(String(value)).format('DD/MM/YYYY');
    },
    formatCurrency(value) {
     
      let sign = '$';
      let decimal = ''; //'.00';
      if(value == 0 ){
        //return `${sign}0${decimal}`;
        return ``;
      }
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;
    },
    print() {
      window.print();
    },

    total(property) {
      return this.data.reduce(function (sum, item) {
        return sum + item[property];
      }, 0)
    },
  },
  computed: {
    totalPrice() {
      return this.data.reduce(function (sum, item) {
        return sum + (item.total_paid_loan + item.total_piad_interest)
      }, 0)
    },
    
  }
};

</script>

<template>
  <Layout>
    <PageHeader @click="print()" :add="{icon: 'bx bx-printer', title: 'general.print'}" :title="$t('report.property.group-summary')" />
      <div class="row seach-area">
        <div class="col-sm-2">
          <Select
            :id="'project_id'"
            :text="'name'"
            :editable="true"
            :list="projects"
            @change="(event) => projectChanged(event)"
            v-model="project_id"
          />
        </div>
        <div class="col-sm-2">
          <Select
            :id="'group_id'"
            :text="'name'"
            :editable="true"
            :list="groupData"
            v-model="group_id"
          />
        </div>
        <div class="col-sm-2">
          <Input 
            :type="'date'"
            :id="'start_date'"
            v-model="start_date"
          /> 
        </div>
        <div class="col-sm-2">
          <Input 
            :type="'date'"
            :id="'end_date'"
            v-model="end_date"
          /> 
        </div>
        <div class="col-sm-2">
          <Button v-bind:icon="'bx bx-search'"
            @click="submitSearch()" 
            v-bind:buttonType="'button'"
            v-bind:variant="'primary'"
            v-bind:title="$t('general.search')" 
          />
        </div>
      </div>
      <div id="print-area">
        <!-- <center> -->
          
          <div class="col dblack box-a4l">
            <table width="100%" class="content-general bottom">
              <tr>
                <td width="9%"><p>&nbsp;</p></td>
                <td width="50%"><p>&nbsp;</p></td>
              </tr>
              <tr>
                <td><img src="@/assets/images/h-logo.svg" alt width="80" /></td>
                <td>
                  <p class="khb h4"><b>ក្រុមហ៊ុនលំនៅឋាន<span class="g-color"> អេចស៊ី </span>ឯ.ក</b></p>
                  <p class="enb h5"><b>LOMNOV THAN <span class="g-color">HC</span> CO., LTD</b></p>
                  <p class="khs h8">អាសយដ្ឋានដីឡូតិ៍លេខៈ ៧៤២ ផ្លូវលេខៈ ១៩៥២ ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ</p>
                  <p class="khs h8">ទូរស័ព្ទលេខៈ 092 685 009 | 098 685 009 Email: account@h-residence.net</p>
                </td>
                <td class="">
                    <p class="khb"><u>របាយការណ៍កែរប្រែតម្លៃ</u></p>
                    <p class="khb"><u>គម្រោង: {{this.project_name}}</u></p>
                </td>
              </tr>
              
            </table>
            <br/>
            <table class="content-general h8 project-sumary-table report-table" width="100%">
              
                <tr class="thead">
                  <th rowspan="2">#</th>
                  <th rowspan="2">{{$t('general.project')}}</th>
                  <th rowspan="2">{{$t('general.changing_date')}}</th>
                  <th rowspan="2">{{$t('general.group')}}</th>
                  <th rowspan="2">{{$t('general.unit')}}</th>
                  <th rowspan="2">{{$t('general.old_price')}}</th>
                  <th colspan="2">{{$t('general.price_changing')}}</th>
                  <th rowspan="2">{{$t('general.new_price')}}</th>
                  <th rowspan="2">{{$t('general.changer')}}</th>
                </tr>
                <tr class="thead">
                  <th>{{$t('general.price_down')}}</th>
                  <th>{{$t('general.price_up')}}</th>
                </tr>
              <tbody>
                <tr v-for="(list, index) in data" :key="index" >
                  <td>{{index + 1}}</td>
                  <td>{{list.project}}</td>
                  <td>{{list.changing_date}}</td>
                  <td>{{list.project_group}}</td>
                  <td>{{list.property_code}}</td>
                  <td>{{formatCurrency(list.old_price)}}</td>
                  <td>{{formatCurrency(list.price_down)}}</td>
                  <td>{{formatCurrency(list.price_up)}}</td>
                  <td>{{formatCurrency(list.new_price)}}</td>
                  <td>{{list.changer}}</td>
                </tr>
              </tbody>
                <tr class="tfoot" v-if="data">
                  <td colspan="5">{{$t('report.total')}}</td>
                  <td>{{formatCurrency(total('old_price'))}}</td>
                  <td>{{formatCurrency(total('price_down'))}}</td>
                  <td>{{formatCurrency(total('price_up'))}}</td>
                  <td>{{formatCurrency(total('new_price'))}}</td>
                  <td></td>
                </tr>
            </table>
          
            <div class="row mt-3">
              <div class="col">
                <center>
                  <p class="khs">បានពិនិត្យនិងឯកភាព<br>អគ្គនាយកក្រុមហ៊ុន</p>
                </center>
              </div>
              <div class="col">
                <center>
                  <p class="khs">បានពិនិត្យនិងឯកភាព<br>អគ្គនាយកក្រុមហ៊ុន</p>
                </center>
              </div>
              <div class="col">
                <center>
                  <p class="khs">បានពិនិត្យនិងឯកភាព<br>នាយកផ្នែកបច្ចេកទេស</p>
                </center>
              </div>
              <div class="col">
                <center>
                  <p class="khs">បានពិនិត្យនិងឯកភាព<br>ប្រធានគ្រប់គ្រងទូទៅ</p>
                </center>
              </div>
            </div>
          </div>  
        <!-- </center> -->
      </div>
    <!-- end row -->
  </Layout>
</template>